export default __webpack_public_path__ + "static/media/patrick-tomasso-Oaqk7qqNh_c-unsplash.8ca90014.jpg";